import { useRef } from "react";
import { useHover } from "usehooks-ts";
import style from "./data-editor-integration-item.module.css";
import { MissingDataIcon } from "../../../icons/missing-data-icon";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";

export function MissingColumnInFields({ missingColumns }: { missingColumns: number }) {
  if (missingColumns === 0) return null;

  return (
    <div className={style.field}>
      <div className={style.missingColumnsIndicator}>
        <div className={style.missingColumnsIcon}>
          <MissingDataIcon />
        </div>
        <span>{missingColumns === 1 ? "Missing column" : `${missingColumns} Missing columns`}</span>
      </div>
    </div>
  );
}

export function MissingColumnsInItem({ missingColumns }: { missingColumns: number }) {
  const indicatorRef = useRef<HTMLDivElement>(null);
  const hover = useHover(indicatorRef);

  if (missingColumns === 0) return null;

  const tooltipLabel = missingColumns === 1 ? "Missing column" : `${missingColumns} Missing columns`;

  return (
    <>
      <div className={style.field} ref={indicatorRef}>
        <div className={style.missingColumnsIndicator}>
          <div className={style.missingColumnsIcon}>
            <MissingDataIcon />
          </div>
        </div>
      </div>
      {hover && (
        <Tooltip
          label={tooltipLabel}
          relativeTo={indicatorRef}
          side="left"
          customStyle={{ borderRadius: "6px", fontSize: "10px", backgroundColor: "#355270" }}
          margin={-6}
          arrowSize={8}
        />
      )}
    </>
  );
}
